import { GalleryVerticalEnd } from "lucide-react"
import logo from "@/assets/ramsden-light.png"
import background from "@/assets/login-bg.png"
import { motion } from "framer-motion"

export default function LoginFlow({ children }) {
    return (
        <div className="grid min-h-screen lg:grid-cols-[3fr_5fr] bg-white">
            {/* Left: Background image (desktop only) */}
            <div className="bg-muted relative hidden lg:block order-1 lg:order-none">
                <img
                    src={background}
                    alt="Background"
                    className="absolute inset-0 h-full w-full object-cover dark:brightness-[0.2] dark:grayscale"
                />
            </div>

            {/* Right: Login area */}
            <div className="relative flex flex-col gap-4 p-6 md:p-10 order-2 lg:order-none bg-white lg:bg-transparent">

                {/* Mobile: Faded background behind form */}
                <div className="absolute inset-0 lg:hidden z-0 opacity-10">
                    <img
                        src={background}
                        alt="Faded mobile background"
                        className="h-full w-full object-cover"
                    />
                </div>

                {/* Logo */}
                <div className="relative z-10 flex justify-center gap-2 md:justify-start">
                    <div className="flex items-center gap-2 font-medium">
                        <div className="bg-[#8C3161] text-white flex size-6 items-center justify-center rounded-md">
                            <GalleryVerticalEnd className="size-4" />
                        </div>
                        <img src={logo} alt="Ramsden Logo" className="h-6 w-auto md:h-6" />
                    </div>
                </div>

                {/* Form */}
                <div className="relative z-10 flex flex-1 items-center justify-center">
                    <motion.div
                        className="w-full max-w-xs lg:bg-transparent lg:backdrop-blur-none lg:shadow-none lg:p-0 bg-white/80 backdrop-blur-md rounded-2xl shadow-lg p-6"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        {children}
                    </motion.div>
                </div>
            </div>
        </div>
    )
}
